import Cookies from 'cookies'

const destroyServerCookies = (req: Request, res: Response, cookieNames: string[] = []): void => {
    const dateInPast = new Date(0)
    const cookies = new Cookies(req, res)

    cookieNames.forEach(cookieName => cookies.set(cookieName, '', { maxAge: dateInPast }))
}

export { destroyServerCookies }
